import './assets/main.css'
import './https/icons/iconfont.css'
// 已移除 global.css 引用

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Antd, { message } from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'

import App from './App.vue'
import router from './router'
import { initStores } from '@/stores'
import { ensureLatestAppVersion, installChunkLoadRecovery, isVersionSensitiveRoute } from '@/utils/appVersion'

installChunkLoadRecovery()

router.beforeEach(async (to) => {
  if (!isVersionSensitiveRoute(to.path)) return true
  return await ensureLatestAppVersion() ? true : false
})

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
app.use(Antd)

// 配置 message 组件的 z-index，确保在 NavBar 之上显示
message.config({
  top: '80px', // 距离顶部的位置，避开 NavBar
  duration: 3,
  maxCount: 3,
  getContainer: () => document.body,
  prefixCls: 'ant-message-custom'
})

// 修改初始化流程，确保stores完全初始化后再挂载router和应用
async function initializeApp() {
  try {
    const isCurrentVersion = await ensureLatestAppVersion(true)
    if (!isCurrentVersion) return
    // 1. 先初始化所有stores
    await initStores()
    // 2. 然后挂载router（确保路由守卫能访问到完整的store状态）
    app.use(router)
    // 3. 最后挂载应用
    app.mount('#app')
  } catch (error) {
    console.error('❌ 应用初始化失败:', error)
    // 即使stores初始化失败，也要确保应用能启动
    if (!app._container) {
      app.use(router)
      app.mount('#app')
    }
  }
}

// 启动应用
initializeApp()
